var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38329 0.255859C2.45169 0.255859 0.0820312 2.65388 0.0820312 5.62056C0.0820312 8.58723 2.45169 10.9853 5.38329 10.9853C8.31488 10.9853 10.6845 8.58723 10.6845 5.62056C10.6845 2.65388 8.31488 0.255859 5.38329 0.255859ZM8.03391 7.54648L7.28644 8.30291L5.38329 6.37698L3.48014 8.30291L2.73266 7.54648L4.63581 5.62056L2.73266 3.69463L3.48014 2.93821L5.38329 4.86413L7.28644 2.93821L8.03391 3.69463L6.13076 5.62056L8.03391 7.54648Z",
    fill: "#FF2929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.bbc1a4ee15fb200eb3a6e2b36da77f0a.svg";
export { ForwardRef as ReactComponent };